<div class="success-container">
  <mat-icon class="success-icon">check_circle</mat-icon>
  <h5>{{ 'Your profile info has been updated!' | translate }}</h5>

  @if (isProfileSettings) {
    <div class="next-section">
      <p>
        {{ 'Your changes have been saved successfully.' | translate }}
      </p>
      <button class="home-btn" (click)="goHome()">
        <mat-icon>home</mat-icon>
        {{ 'Go to Homepage' | translate }}
      </button>
    </div>
  } @else {
    <div class="next-section">
      <h3>{{ 'whats next' | translate }}</h3>
      <p>
        {{ 'waitingForConfirmation' | translate }}
      </p>
    </div>
  }
</div>
